import { createContext, useContext } from "react";
/**
 * Path for the 3D viewer script, depends on your application.
 */
export const CadClickViewer3DScriptUrlContext = createContext("kim-viewer-3d/Viewer3D.1.7.1.min.js");
/**
 * Returns path for the 3D viewer script.
 * @returns
 */
export function useCadClickViewer3DScriptUrl() {
    return useContext(CadClickViewer3DScriptUrlContext);
}
/**
 * Extracts the version from the 3D viewer script URL.
 * @returns {string | null} The extracted version or null if not found.
 */
export function useCadClickViewer3DVersion() {
    const scriptUrl = useCadClickViewer3DScriptUrl();
    const versionMatch = scriptUrl.match(/Viewer3D\.(\d+\.\d+\.\d+)(\.min)?\.js/);
    return versionMatch ? versionMatch[1] : null;
}
//# sourceMappingURL=CadClickViewer3DScriptUrlContext.js.map